import { Outlet } from 'react-router-dom';

import routes from '@routes';
import { Page } from '@common/ui/Page';
import RequestDrawer from '../organisms/RequestDrawer';
import { MfaBanners } from '@common/organisms/MfaBanners';
import { Flags } from '@common/utils/flags/feature-flags';
import { useFlagFixed } from '@common/utils/flags/use-flag-fixed';
import { AnalyticsEvents } from '@common/utils/analytics/events';
import { useMemo } from 'react';

export default function RequestsLayout() {
  const { isEnabled: isEntitlementRequestEnabled } = useFlagFixed(Flags.ENTITLEMENT_REQUEST_FORM);
  const { isEnabled: isIntegrationRequestHidden } = useFlagFixed(Flags.HIDE_INTEGRATION_REQUEST_FORM);

  const tabs = [
    { label: routes.OpenRequests.label, to: routes.OpenRequests.path },
    {
      label: routes.ClosedRequests.label,
      to: routes.ClosedRequests.path,
    },
  ];

  if (!isIntegrationRequestHidden) {
    tabs.push({
      label: routes.Templates.label,
      to: routes.Templates.path,
    });
  }

  const toRoute = useMemo(() => {
    if (isIntegrationRequestHidden && !isEntitlementRequestEnabled) {
      return routes.BundleRequest.path;
    } else if (isEntitlementRequestEnabled) {
      return routes.ResourcesRequest.path;
    }
    return routes.NewRequest.path;
  }, [isIntegrationRequestHidden, isEntitlementRequestEnabled]);

  return (
    <Page
      title="My Requests"
      tabs={tabs}
      button={{
        label: 'New Request',
        href: toRoute,
        dataTrigger: AnalyticsEvents.NewRequestButtonClicked,
      }}
      banner={<MfaBanners />}
    >
      <Outlet />
      <RequestDrawer />
    </Page>
  );
}
